import { useIsAuth } from '@/entities/user/session';
import { filterNavigation } from '@/app/lib/navigation/filter-navigation';
import { useUserRules } from '@/entities/user/access-rule';

import { checkRules } from '@/entities/user/access-rule';
import { getRoutes } from '@/app/lib/navigation/get-routes';
import { filterTree } from '@/shared/lib/utils/tree/filter-tree';
import { useMemo } from 'react';

const navigationTree = getRoutes({
  selectProperties: [
    'children',
    'icon',
    'label',
    'rules',
    'to',
    'show',
    'hidden',
    'component',
  ],
});
export const useNavigationByRules = (
  filterHidden: boolean = true,
): [ReturnType<typeof filterNavigation>, boolean, unknown] => {
  const { data: rules, error, isError, isFetching } = useUserRules();
  const isAuth = useIsAuth();
  const navigation = useMemo(
    () =>
      !isFetching && isAuth
        ? filterTree(navigationTree, 'children', (x) =>
            !x?.children && !x?.component
              ? false
              : checkRules(x.rules, rules) && (filterHidden ? !x.hidden : true),
          )
        : [],
    [rules, isFetching, isAuth],
  );

  return [navigation, isFetching, isError ? error : null];
};